import type { VBtnProps } from '@/types/vuetify-components.ts'
import type { ValueOf } from '@deepcloud/deep-ui-utils'

export const STORE_SERVICES = {
  HOOP: 'hoop',
  ABA_NINJA: 'aba_ninja',
} as const

export type StoreServices = ValueOf<typeof STORE_SERVICES>

type StoreServiceDataContentListItem = {
  icon?: string
  title?: string

  action(): void
}

export type StoreServiceDataContentList = {
  title: string
  items?: StoreServiceDataContentListItem[]
}

export type StoreServiceData = {
  title: string
  subtitle: string
  textCategory: string
  textPrice: string
  textLanguages: string
  textContent: string
  logoId: string
  content: string
  carouselImagesSrc: {
    en: string[]
    de: string[]
    fr: string[]
    it: string[]
  }
  contentList?: StoreServiceDataContentList
  btnContinue?: VBtnProps
}

export type StoreServiceCarouselItem = {
  src: string
}

export type StoreServicesData = Record<StoreServices, StoreServiceData>
